import Api from "@/api/users";
import { useRouter } from "vue-router";
import { ref, reactive, toRefs } from "vue";

export default function users(id) {
    const router = useRouter();

    // Реактивные переменные
    const state = reactive({
        usersModels: ref([]),
        baseUrl: process.env.VUE_APP_API,
        openPickImage: ref(false),
        login: ref(""),
        email: ref(""),
        avatar: ref(""),
        name: ref(""),
        surname: ref(""),
        patronymic: ref(""),
        birthday: ref(""),
        password: ref("")
    });

    // Функции
    const createUser = async () => {
        await Api.createModel({
            login: state.login,
            email: state.email,
            avatar: state.avatar,
            name: state.name,
            password: state.password,
        });
        router.push("/settings/");
    };

    const updateUser = async () => {
        await Api.updateModel(id, {
            login: state.login,
            email: state.email,
            avatar: state.avatar,
            name: state.name,
            surname: state.name,
            patronymic: state.patronymic,
            birthday: state.birthday,
        });
        alert("Пользователь успешно обновлен");
    };

    const deleteUser = async () => {
        let isDelete = confirm("Вы действительно хотите удалить пользователя?");
        if (isDelete === true) {
            await Api.deleteModel(id);
            router.push("/settings/");
        }
    };

    const getUser = async () => {
        let response = await Api.getModel(id, { expand: "userProfile" });
        state.login = response.data.login;
        state.email = response.data.email;
        state.avatar = response.data.avatar;
        if (response.data.userProfile) {
            state.name = response.data.userProfile.name;
            state.surname = response.data.userProfile.name;
            state.patronymic = response.data.userProfile.patronymic;
            state.birthday = response.data.userProfile.birthday;
        }
    };

    const getUsers = async () => {
        let response = await Api.getModels({});
        state.usersModels = response.data;
    };

    // Возвращаем всё скопом
    return {
        ...toRefs(state),
        createUser,
        updateUser,
        deleteUser,
        getUser,
        getUsers
    };
}